import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
const CardSkeleton = ({ sx, width, height }) => {
	return (
		<Box sx={{ minWidth: "55rem", height: "48rem", ...sx }}>
			<Skeleton sx={{ width: width, height: height }} variant="circular" animation="wave" />
		</Box>
	);
};

export default CardSkeleton;
